import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotes-two',
  templateUrl: './quotes-two.component.html',
  styleUrls: ['./quotes-two.component.scss']
})
export class QuotesTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
